import React from "react";
import { Button, Col, FormCheck, Row } from "react-bootstrap";
import CreatedIcon from "../../assets/icons/Icon_Library/application icons/assets/events/step_complete-01.svg2";
import OfficeIcon from "../../assets/icons/Icon_Library/application icons/assets/events/locations/location_office-01.svg2";
import RecipientsIcon from "../../assets/icons/Icon_Library/application icons/assets/events/recipients-01.svg2";
import SentIcon from "../../assets/icons/Icon_Library/application icons/assets/events/send_method-01.svg2";
import StartIcon from "../../assets/icons/Icon_Library/application icons/assets/events/timeline-01.svg2";
import AssetsIcon from "../../assets/icons/Icon_Library/application icons/assets/assets.svg2";
import { eventTypes } from "./EventType";
import MyIcon from "../Common/MyIcon";
import EventAddTicketModal from "./EventAddTicketModal";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import TokenEditor from "../Builder/Components/TokenEditor";

function EventComplete({
  handleSave,
  event,
  setEvent,
  affected,
  isEventMinimal,
}) {
  const eventType = eventTypes.find((type) => type.value === event.Type);

  return (
    <Row className="py-3 mt-2 ps-4 pe-4 m-2">
      <Col className="col-5 border-end pe-4">
        {!isEventMinimal && (
          <div className="my-2">
            <div className="fw-bold fs-4"> Do you want to add a ticket?</div>
            <div className="">
              <FormCheck
                id="add-ticket-to-event-checkbox"
                checked={event.CreateTicket === "Yes"}
                label="Yes, add a ticket for this event"
                onChange={(e) =>
                  setEvent({
                    ...event,
                    CreateTicket: e.target.checked ? "Yes" : "No",
                  })
                }
              />
              {event.CreateTicket === "Yes" ? (
                <div className="bg-white p-3 rounded-2 my-3">
                  Add existing ticket or leave blank to generate a new one.
                  <Input
                    label="Add Ticket to Event"
                    value={[event.Ticket]}
                    onChange={([v]) => setEvent({ ...event, Ticket: v })}
                    options={[]}
                    className="my-2"
                  />
                </div>
              ) : null}
            </div>
            <hr className="my-4" />
          </div>
        )}

        <div className="d-flex flex-column align-items-center">
          <CreatedIcon width={60} className="mb-3" />
          <span className="fs-4 fw-bold">Event Ready</span>
          <div className="text-secondary align-items-center text-center mt-2">
            The event is ready to be created and can now be activated to begin
            notifications.
          </div>
          <Button
            className="bg-colored-reverse rounded-pill mt-3 p-2 px-4 border-0  fw-bold"
            onClick={handleSave}
          >
            ACTIVATE NOW
          </Button>
        </div>
      </Col>
      <Col className="col-7 ps-4">
        <div className="my-2">
          <span className="fs-4 fw-bold">Summary of this Event</span>
          <div className="text-secondary ">
            This summary shows the key details, scope, and delivery settings for
            this event.
          </div>
        </div>
        <div className="d-flex align-items-center mt-3 justify-content-between">
          <div className="d-flex align-items-center">
            <div className="align-items-center d-flex ">
              {eventType?.icon ? (
                <MyIcon width={40} Icon={eventType?.icon} className="me-3" />
              ) : null}{" "}
              <span className="fw-bold">{eventType?.label}</span>
            </div>
            <div className="ms-4">
              <div>
                <span>Name:</span>
                <span className="fw-bold ">{event.Name}</span>
              </div>
              <div>
                <span>Reference:</span>
                <span className="fw-bold ">{event.Reference}</span>
              </div>
              <div>
                <span>Description:</span>
                <span className="text-secondary ">{event.Description} </span>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <div className="fw-bold me-2">Alert level:</div>{" "}
            <div
              className="border-0 fw-bold px-4 p-2"
              style={{
                backgroundColor:
                  event.Severity === "critical"
                    ? "red"
                    : event.Severity === "high"
                    ? "orange"
                    : event.Severity === "medium"
                    ? "gold"
                    : "seagreen",
              }}
            >
              {event?.Severity || "low"}
            </div>
          </div>
        </div>
        <hr className="text-secondary" />
        {event?.Areas?.[0]?.geometry?.coordinates ? (
          <div className="my-3">
            <OfficeIcon width={25} className="me-2" />{" "}
            <span className="fw-bold">Area:</span>{" "}
            {event?.Areas?.[0]?.geometry?.type || "N/A"}
          </div>
        ) : null}
        {/* <div className="my-3">
          <OfficeIcon width={25} className="me-2" /> Office HQ(North)
        </div> */}
        {/* <div className="my-3">
          <OfficeIcon width={25} className="me-2" /> Office HQ(South)
        </div> */}
        <div className="my-3">
          <RecipientsIcon width={25} className="me-2" /> Sending to
          <span className="fw-bold"> {affected?.contacts || 0} recipients</span>
        </div>
        <div className="my-3">
          <StartIcon width={25} className="me-2" />{" "}
          <span className="fw-bold">Starts:</span>
          {event?.StartedAt
            ? new Date(event.StartedAt).toLocaleString([], {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "N/A"}
          <span className="fw-bold ms-4">ENDS: </span>
          {event?.EndedAt
            ? new Date(event.EndedAt).toLocaleString([], {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })
            : null}{" "}
        </div>
        <div className="my-3">
          <SentIcon width={25} className="me-2" />
          <span className="fw-bold"> Sent via:</span>
          <span className="ms-1">{event?.PreferredChannels?.join(", ")}</span>
        </div>
        <div className="my-3">
          <SentIcon width={25} className="me-2" />
          <span className="fw-bold"> Message to send:</span>
          <div className="bg-white rounded-3 p-3">
            <TokenEditor
              preview="email"
              rawEditorState={
                JSON.parse(event?.EditorMessage || "{}").EditorState
              }
              onChange={() => null}
            />
          </div>
        </div>
        <div className="my-3">
          <AssetsIcon width={25} className="me-2" />
          <span className="fw-bold"> Affected Assets:</span>
          <span className="ms-1"> {affected?.assets || 0}</span>
        </div>
      </Col>
    </Row>
  );
}

export default EventComplete;
